import { render } from "./SummaryComponent.vue?vue&type=template&id=35da1972&scoped=true"
import script from "./SummaryComponent.vue?vue&type=script&lang=js"
export * from "./SummaryComponent.vue?vue&type=script&lang=js"

import "./SummaryComponent.vue?vue&type=style&index=0&id=35da1972&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35da1972"]])

export default __exports__